export default "__VITE_ASSET__BIuR5YzJ__"